import { useState, useEffect } from 'react';
import { CalculatorState } from '../components/calculator/CalculatorManager';

const INITIAL_STATE: CalculatorState = {
  calculators: [0],
  results: [],
  showTrend: false
};

export function useCalculatorState() {
  const [state, setState] = useState<CalculatorState>(() => {
    const saved = sessionStorage.getItem('calculatorState');
    return saved ? JSON.parse(saved) : INITIAL_STATE;
  });

  const updateState = (newState: CalculatorState | ((prev: CalculatorState) => CalculatorState)) => {
    setState(prev => {
      const nextState = typeof newState === 'function' ? newState(prev) : newState;
      sessionStorage.setItem('calculatorState', JSON.stringify(nextState));
      return nextState;
    });
  };

  return { state, updateState };
}